// prd.md §6 point 4 / architecture.md §4.1: lifecycle events the host page can listen to
// without knowing anything about the widget's internals — `bubbles: true, composed: true` so
// they cross the shadow boundary and reach `element.addEventListener(...)` on the custom
// element itself (or anywhere above it via bubbling), which is exactly what lets a host page's
// GA4/GTM/CRM tracking hook in without the widget knowing which analytics system that is.
export type AdPolicyCheckerEventName =
  | "adpresso:scan-started"
  | "adpresso:scan-progress"
  | "adpresso:scan-complete"
  | "adpresso:email-submitted"
  | "adpresso:error";

export interface EventPayloads {
  "adpresso:scan-started": { scanId: string; domain: string; originTag: string };
  "adpresso:scan-progress": { scanId: string; urlsDone: number; urlsTotal: number };
  "adpresso:scan-complete": { scanId: string; domainScore: number | null; officialViolationCount: number };
  "adpresso:email-submitted": { scanId: string; trigger: "during_scan" | "post_report" };
  "adpresso:error": { scanId: string | null; code: string; message: string };
}

export function dispatchWidgetEvent<T extends AdPolicyCheckerEventName>(
  target: HTMLElement,
  name: T,
  detail: EventPayloads[T],
): void {
  target.dispatchEvent(new CustomEvent(name, { detail, bubbles: true, composed: true }));
}
